export default __webpack_public_path__ + "static/schumpeter-801c78b923f165dfab1700c314e141d5.jpg";